import { createRouter, createWebHistory } from "vue-router";
import { useAppStore } from "@/stores/app";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("@/views/HomeView.vue"),
            props: { mode: "collection" },
            meta: { title: "Collection", requiresAuth: true },
        },
        {
            path: "/discover",
            name: "discover",
            component: () => import("@/views/HomeView.vue"),
            props: { mode: "discover" },
            meta: { title: "Discover", requiresAuth: true },
        },
        {
            path: "/video/:javId",
            name: "video-detail",
            component: () => import("@/views/VideoDetailView.vue"),
            props: true,
            meta: { title: "Video Detail", requiresAuth: true },
        },
        {
            path: '/actresses',
            name: 'actresses',
            component: () => import('@/views/ActressView.vue'),
            meta: { title: 'Actresses', requiresAuth: true },
        },
        {
            path: '/tags',
            name: 'tags',
            component: () => import('@/views/TagsView.vue'),
            meta: { title: 'Tags', requiresAuth: true },
        },
        {
            path: "/library",
            name: "library",
            component: () => import("@/views/LibraryView.vue"),
            meta: { title: "Libraries", requiresAuth: true },
        },
        {
            path: "/settings",
            name: "settings",
            component: () => import("@/views/SettingsView.vue"),
            meta: { title: "Settings" /* dynamic auth — see guard */ },
        },
        {
            path: "/login",
            name: "login",
            component: () => import("@/views/LoginView.vue"),
            meta: { title: "Sign in" },
        },
        {
            path: "/organize",
            name: "organize",
            component: () => import("@/views/OrganizeView.vue"),
            meta: { title: "Organize", requiresAuth: true },
        },
        {
            path: "/scrape",
            name: "scrape",
            component: () => import("@/views/ScrapeView.vue"),
            meta: { title: "Scrape (admin)", requiresAuth: true },
        },
        {
            path: "/downloads",
            name: "downloads",
            component: () => import("@/views/DownloadsView.vue"),
            meta: { title: "Downloads", requiresAuth: true },
        },
        {
            path: "/discover/triage",
            name: "backlog",
            component: () => import("@/views/BacklogView.vue"),
            meta: { title: "Discover triage", requiresAuth: true },
        },
        {
            path: "/triage",
            name: "triage",
            component: () => import("@/views/TriageView.vue"),
            meta: { title: "Triage", requiresAuth: true },
        },
        {
            path: "/taste",
            name: "taste",
            component: () => import("@/views/TasteView.vue"),
            meta: { title: "Taste", requiresAuth: true },
        },
        {
            path: "/faces",
            name: "faces",
            component: () => import("@/views/FacesView.vue"),
            meta: { title: "Faces", requiresAuth: true },
        },
        {
            path: "/trash",
            name: "trash",
            component: () => import("@/views/TrashView.vue"),
            meta: { title: "Trash", requiresAuth: true },
        },
        {
            path: "/tasks",
            name: "tasks",
            component: () => import("@/views/TasksView.vue"),
            meta: { title: "Tasks", requiresAuth: true },
        },
        {
            path: "/:pathMatch(.*)*",
            redirect: "/",
        },
    ],
});

// Single guard handling first-run + auth:
//
//   1. await app.bootstrap() once so we know `configured` + `authenticated`
//   2. if !configured → force /settings (the only writable surface)
//   3. if configured + route requires auth + not authenticated → /login
//   4. if going to /login while already authenticated → /
router.beforeEach(async (to) => {
    const app = useAppStore();
    if (!app.bootstrapped) {
        await app.bootstrap();
    }

    if (app.configured === false) {
        return to.name === "settings" ? true : { name: "settings" };
    }

    if (to.meta.requiresAuth && app.authenticated === false) {
        return { name: "login", query: { next: to.fullPath } };
    }

    if (to.name === "login" && app.authenticated === true) {
        return { name: "home" };
    }

    return true;
});

router.afterEach((to) => {
    const base = "Ahegao";
    const pageTitle = to.meta?.title as string | undefined;
    document.title = pageTitle ? `${pageTitle} — ${base}` : base;
});

export default router;
